import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { BsStars, BsCheckCircleFill } from "react-icons/bs";
import AudioSection from "../../../../components/admin/aiContent/audioSection/AudioSection";
import AvatarSection from "../../../../components/admin/aiContent/avatarSection/AvatarSection";
import VideoSection from "../../../../components/admin/aiContent/videoSection/VideoSection";
import "../../../../assets/css/admin/dashboardcss/AIContent.css";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const AdminAIContent = () => {
  const { baseUrl } = useContext(AppContext);
  const [voice, setVoice] = useState();
  const [avatar, setAvatar] = useState();
  const [video, setVideo] = useState([]);
  const [voiceLoading, setVoiceLoading] = useState(false);
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);

  const audios = [
    { id: "aud_8f7e2c1d", name: "Promo Voice 1", duration: "0:32" },
  ];

  const getVoicesFromHeyGen = () => {
    axios
      .get(`${baseUrl}/admin/esheygen/getvoice`)
      .then((response) => {
        console.log(response.data.response.data);
        setVoice(response.data.response.data);
        setTimeout(() => {
          setVoiceLoading(true);
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAvatarsFromHeyGen = () => {
    axios
      .get(`${baseUrl}/admin/esheygen/getavatar`)
      .then((response) => {
        console.log("Avatar Array:", response.data.data);
        setAvatar(response.data.data);
        setAvatarLoading(true);
      })
      .catch(console.log);
  };

  const getVideosFromHeyGen = () => {
    axios
      .get(`${baseUrl}/admin/esheygen/getvideolist`)
      .then((response) => {
        console.log("Video Raw Response:", response.data);

        const payload = response.data?.data || {};

        const rawVideos =
          payload?.data?.videos ||
          payload?.videos ||
          payload?.data?.data ||
          (Array.isArray(payload?.data) ? payload.data : null) ||
          [];

        console.log("Extracted Videos Array:", rawVideos);

        const mappedVideos = rawVideos.map((v) => ({
          id: v.video_id || v.id || v.video_translate_id || "unknown_id",
          name:
            v.title ||
            v.video_title ||
            v.caption ||
            v.name ||
            "Untitled Video",
          duration: v.duration ? `${Math.round(v.duration)}s` : "",
          url:
            v.video_url ||
            v.url ||
            v.download_url ||
            v.video_url_caption ||
            v.gif_url ||
            null,
          thumbnail:
            v.thumbnail_url ||
            v.cover_url ||
            v.gif_url ||
            null,
        }));

        console.log("Mapped Videos (with url):", mappedVideos);

        setVideo(mappedVideos);
        setVideoLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setVideoLoading(true);
      });
  };

  useEffect(() => {
    getVoicesFromHeyGen();
    getAvatarsFromHeyGen();
    getVideosFromHeyGen();
  }, []);

  const allReady = voiceLoading && avatarLoading && videoLoading;

  return (
    <AdminLayout>
      <div className="es-ai-content-page">
        <Container fluid className="es-ai-content-container">
          {/* Header */}
          <Row className="es-ai-header-row align-items-center mb-4">
            <Col>
              <div className="es-ai-title-wrap">
                <BsStars className="es-ai-title-icon" />
                <div>
                  <h2 className="es-ai-title">AI Content</h2>
                  <p className="es-ai-subtitle">
                    Create and manage AI generated content like audio, avatars
                    and videos.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs="auto">
              <span
                className={`es-ai-status-pill ${
                  allReady ? "es-ai-status-ready" : "es-ai-status-loading"
                }`}
              >
                <BsCheckCircleFill />
                {allReady ? "AI Content Ready" : "Loading Content..."}
              </span>
            </Col>
          </Row>

          {/* Top Row: Audio + Avatar side by side */}
          <Row className="es-ai-top-row g-3 mb-3">
            <Col lg={6}>
              {voiceLoading ? (
                <AudioSection items={audios} voice={voice} />
              ) : (
                <div className="es-ai-loading">
                  <Spinner animation="border" className="es-ai-spinner" />
                </div>
              )}
            </Col>
            <Col lg={6}>
              <AvatarSection items={avatar || []} />
            </Col>
          </Row>

          {/* Videos — full width */}
          <div className="es-ai-sections">
            {videoLoading ? (
              <VideoSection items={video} />
            ) : (
              <div className="es-ai-loading">
                <Spinner animation="border" className="es-ai-spinner" />
              </div>
            )}
          </div>
        </Container>
      </div>
    </AdminLayout>
  );
};

export default AdminAIContent;